import React from 'react'
import PropTypes from 'prop-types'

// material components
import Typography from '@mui/material/Typography'

const styles = {
    root: {
        height: '100%',
        paddingLeft: 10,
        paddingBootom: 10,
    },
}

/**
 * component for use in card component
 * @param classes
 * @param label
 * @param content
 * @returns {*}
 * @constructor
 */
const CardText = ({ classes, label, content }) => (
    <div style={styles.root}>
        { label && (
            label.map(txt => <Typography key={txt} variant="subtitle1" gutterBottom={(label.length === 1)} style={{lineHeight: "18px", marginBottom: 2, fontSize: 18,fontWeight: 400, color: '#fff' }}>{txt}</Typography>)
        )}
        { content && (
            content.map(txt => <Typography key={txt} variant="body1" gutterBottom="true" style={{ fontSize: 14, color: '#fff' }}>{txt}</Typography>)
        )}
    </div>
)

CardText.propTypes = {
    label: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.bool,
    ]),
    content: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.bool,
    ]),
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
}

CardText.defaultProps = {
    label: false,
    content: false,
}

export default CardText
